import Icon from './icon';

export * as Icons from './icons-list';
export default Icon;
